import React from 'react';
import styled from "styled-components";
import ErrorIcon from "../../assets/svg/error-icon";
import WarningIcon from "../../assets/svg/warning-icon";
import SuccessIcon from "../../assets/svg/success-icon";
import {AnimatePresence, motion} from "framer-motion";
import MotionDiv from "../helperComponents/motionDiv";

interface MessageCardProps {
  children: string | JSX.Element | null;
  type: 'success' | 'warning' | 'error';
}

const Card = styled.div `
  width: 100%;
  padding: 9px 42px 8px 16px;
  background: rgba(225, 228, 231, 0.2);
  mix-blend-mode: normal;
  border-radius: 4px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin-bottom: 1rem;
  min-height: 54px;
  font-size: 14px;
  line-height: 19px;
  font-weight: 500;
  a {
    text-decoration: none;
  }
`;

const IconContainer = styled.div `{
  margin-right: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}`;

const MessageCard = (props: MessageCardProps) => {

  let icon;
  switch(props.type) {
    case "error":
      icon = <ErrorIcon/>;
      break;
    case "warning":
      icon = <WarningIcon/>;
      break;
    case "success":
      icon = <SuccessIcon/>;
  }

    return (
      <AnimatePresence>
        {!!props.children && <MotionDiv
        >
          <Card>
            <IconContainer>
              {icon}
            </IconContainer>
            {props.children}
          </Card>
        </MotionDiv>}
      </AnimatePresence>
    )
}

export default MessageCard;
